(() => {
  const desktopNavigation = window.matchMedia('(min-width: 750px)');
  const rotations = new Map();
  const initializeRotation = (footer) => {
    if (rotations.has(footer)) return;
    const cards = [...footer.querySelectorAll('.eco-footer__nature-square')];
    const ids = [...new Set([...footer.querySelectorAll('[data-eco-slide]')].map(el => el.dataset.ecoSlide))];
    if (ids.length < 2) return;
    let index = 0;
    const preloadNext = () => {
      const next = ids[(index + 1) % ids.length];
      cards.forEach(card => card.querySelectorAll('[data-eco-slide]').forEach(el => {
        if (el.dataset.ecoSlide !== next) return;
        const images = el.matches('img') ? [el] : el.querySelectorAll('img');
        images.forEach(img => { img.loading = 'eager'; });
      }));
    };
    preloadNext();
    const timer = window.setInterval(() => {
      if (!footer.isConnected) {
        window.clearInterval(timer);
        rotations.delete(footer);
        return;
      }
      if (document.hidden || cards.some(card => card.contains(document.activeElement) && document.activeElement.matches(':focus-visible'))) return;
      index = (index + 1) % ids.length;
      cards.forEach(card => card.querySelectorAll('[data-eco-slide]').forEach(el => {
        el.hidden = el.dataset.ecoSlide !== ids[index];
      }));
      preloadNext();
    }, 120000);
    rotations.set(footer, timer);
  };

  const syncNavigationCards = (footer) => {
    footer.querySelectorAll('.eco-footer__nav-card').forEach((card) => {
      card.open = desktopNavigation.matches;
    });
  };

  const initializeFooters = (scope = document) => {
    const footers = scope.classList?.contains('eco-footer')
      ? [scope]
      : scope.querySelectorAll('.eco-footer');

    footers.forEach((footer) => {
      initializeRotation(footer);
      if (footer.dataset.responsiveNavigation === 'true') return;

      syncNavigationCards(footer);
      desktopNavigation.addEventListener('change', () => syncNavigationCards(footer));
      footer.dataset.responsiveNavigation = 'true';
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeFooters(), { once: true });
  } else {
    initializeFooters();
  }

  document.addEventListener('shopify:section:load', (event) => initializeFooters(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    rotations.forEach((timer, footer) => {
      if (event.target.contains(footer)) {
        window.clearInterval(timer);
        rotations.delete(footer);
      }
    });
  });

  let openingPreferences = false;
  const openPreferences = async (link) => {
    openingPreferences = true;
    link.setAttribute('aria-busy', 'true');
    try {
      const deadline = Date.now() + 8000;
      while (typeof window.privacyBanner?.showPreferences !== 'function') {
        if (Date.now() >= deadline) throw new Error('Cookie banner unavailable');
        await new Promise((resolve) => window.setTimeout(resolve, 200));
      }
      await window.privacyBanner.showPreferences();
    } catch (error) {
      window.console.warn('Cookie preferences unavailable', error);
      window.location.assign(new URL('/policies/privacy-policy#cookies', window.location.href).href);
    } finally {
      link.removeAttribute('aria-busy');
      openingPreferences = false;
    }
  };

  document.addEventListener('click', (event) => {
    if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest?.('a[href]');
    if (!link) return;
    let url;
    try {
      url = new URL(link.getAttribute('href'), document.baseURI);
    } catch {
      return;
    }
    if (url.origin !== window.location.origin || url.hash !== '#shopifyReshowConsentBanner') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (!openingPreferences) void openPreferences(link);
  }, true);
})();
